import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LanguagesEnum, LectureTypeEnum } from 'src/app/submit-lecture/lecture.values';

@Component({
  selector: 'language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements ICellRendererAngularComp {
  public get languagesEnum(): typeof LanguagesEnum {
    return LanguagesEnum;
  }
  refresh;
  language: string;
  private params: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.language = this.params.data?.language;
  }

  isLang = (lang): boolean => {
    if (this.language === lang) {
      return true;
    }
    return false;
  }

}
